export class ProductShoppingCar {
  
  id: number;
  orderId: number;
  productId: number;
  description: string;
  description2: string;
  image: string;
  name: string;
  note: string;
  quantity: number;
  price: number;
  discount: number;
  stackable: boolean;
  subtotal: number;
  total: number;
  value: number;
  selected: boolean;

	constructor( p ?: any) {
		this.id = p ? p.id : null;
    this.orderId = p ? p.order_id : null;
    this.productId = p ? p.product_id : null;
    this.description = p ? p.product_description : null;
    this.description2 = p ? p.description : null;
    this.image = p ? p.product_image : null;
    this.name = p ? p.product_name : null;
    this.note = p ? p.note : '';
    this.quantity = p ? p.quantity : null;
    this.price = p ? p.price : null;
    this.discount = p ? p.discount : null;
    this.stackable    = p ? p.stackable : null;
    this.subtotal = p ? p.subtotal : null;
    this.total = p ? p.total : null;
    this.value = p ? p.value : null;
    this.selected = false;
  }
  
  mapProduct(list: any[]): ProductShoppingCar[] {
    let newList: ProductShoppingCar[] = [];
    list.forEach((item: any) => {
      let newItem: ProductShoppingCar = new ProductShoppingCar(item);
      newList.push(newItem);
    });
    return newList;
  }

}
